var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8085,
    cy: 34.161,
    r: 33.871,
    fill: "#6CC399"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1914 31.3063C47.1914 32.461 47.1914 35.3478 45.1914 36.5025L31.4825 44.4173C29.4825 45.572 26.9825 44.1287 26.9825 41.8193V25.9895C26.9825 23.6801 29.4825 22.2368 31.4825 23.3915L45.1914 31.3063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a98d6229a0cae840ec6bd3f1b424e379.svg";
export { ForwardRef as ReactComponent };